import { ALL_NODES, type NodeId } from "./graph";

/**
 * Splits `arr` into `k` contiguous chunks with near-equal size.
 * The first `arr.length % k` chunks are one larger than the rest.
 * If k > arr.length, trailing chunks are empty.
 */
export function splitContiguous<T>(arr: readonly T[], k: number): T[][] {
  if (k <= 0) return [];
  const n = arr.length;
  const base = Math.floor(n / k);
  const rem = n % k;
  const out: T[][] = [];
  let idx = 0;
  for (let i = 0; i < k; i++) {
    const size = base + (i < rem ? 1 : 0);
    out.push(arr.slice(idx, idx + size));
    idx += size;
  }
  return out;
}

/**
 * Assigns the 10 organ nodes to peers as contiguous slices of `ALL_NODES`.
 * This keeps each peer's organs graph-adjacent so mental model stays coherent
 * (e.g. Leber + Gallenblase cluster naturally at the same player).
 */
export function assignOrgans(peerIds: readonly string[]): Map<string, NodeId[]> {
  const map = new Map<string, NodeId[]>();
  if (peerIds.length === 0) return map;
  const segments = splitContiguous(ALL_NODES, peerIds.length);
  peerIds.forEach((id, i) => map.set(id, segments[i] ?? []));
  return map;
}
